import * as React from "react";

import "./table.scss";

import {isApiTrue} from "@Common/logic/is-api-true";
import {cs}        from "@Common/react/chain-services";

import {Checkbox}    from "../../../../../../../../common/design2/checkbox/checkbox";
import {DataTableD1} from "../../../../../../../../common/design2/data-table/data-table-d1";
import {getStreet}   from "../../../../../radius/step-1-search/streets-section/common/get-street";

export const Table = (
    {
        masterCheckbox, filteredRecords, getFooter, count, renderActions,
    }
) => cs(
    () => DataTableD1({
        className: "table-5vw",
        pageSize: 10,
        columns: Columns({
            count,
            masterCheckbox,
        }),
        darkRows: "even",
        rows: filteredRecords.map((r) => {
            const checked = !r.excluded;
            return {
                key: r.street.address,
                columns: [
                    {
                        render: () => Checkbox({
                            checked,
                            onClick: () => r.setExcluded(checked),
                            xdQaName: "Build Street List "+r.street.address,
                        }),
                    },
                    {
                        render: () => <>
                            <div className="text" xd-qa-type="label" xd-qa-name={"Build Street List "+r.street.address}>
                                {r.street.address}
                            </div>
                            <div className="count" xd-qa-type="label" xd-qa-name={"Build Street List "+r.street.address+" Count"}>
                                ({r.addresses.filter((a) => isApiTrue(a.display_address)).length})
                            </div>
                        </>,
                        sortValue: () => r.street.address,
                    },
                    {
                        render: () => renderActions.startHouseAction(r),
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Street List "+r.street.address+" Start House",
                        },
                    },
                    {
                        render: () => renderActions.endHouseAction(r),
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Street List "+r.street.address+" End House",
                        },
                    },
                    {
                        render: () => r.street.zip_code,
                        sortValue: () => r.street.zip_code,
                        domAttrs: {
                            "xd-qa-type": "label",
                            "xd-qa-name": "Build Street List "+r.street.address+" Street Zip Code",
                        },
                    },
                    {
                        render: () => <>
                            {renderActions.editAction(r)}

                        </>,
                    },
                ],
            };
        }),
        emptyAction: {
            label: "No street(s) found",
        },
        getFooter: ({colCount, pagination}) => ({
            columns: [
                {
                    colSpan: colCount,
                    render: () => getFooter({pagination})
                },
            ],
        }),
    }),
);


const Columns = ({masterCheckbox, count}) => [
    {
        width: "1%",
        className: "checkbox",
        render: () => Checkbox({
            ...masterCheckbox,
            xdQaName: "Build Street List Street Master Checkbox",
        }),
    },
    {
        width: "20%",
        label: "STREET",

        subTitle: `(${count.selected} of ${count.total} streets selected)`,

        className: "address",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Street List Street",
        },
    },
    {
        width: "1%",
        label: "START HOUSE",
        className: "start-house",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Street List Start House",
        },
    },
    {
        width: "1%",
        label: "END HOUSE",
        className: "end-house",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Street List End House",
        },
    },
    {
        width: "1%",
        label: "ZIP CODE",
        className: "zip",
        sortable: {
            defaultDirection: "asc",
        },
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Street List Street Zip Code",
        },
    },
    {
        width: "1%",
        label: "ACTION",
        className: "actions",
        domAttrs: {
            "xd-qa-type": "label",
            "xd-qa-name": "Build Street List Action",
        },
    },
];